import { useEffect, useState } from 'react'

export const useMediaQuery = (mediaQuery: string) => {
  const [isMatch, setIsMatch] = useState(false)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery)
    const documentChangeHandler = () => {
      setIsMatch(mediaQueryList.matches)
    }

    mediaQueryList.addEventListener('change', documentChangeHandler)
    documentChangeHandler()

    return () => {
      mediaQueryList.removeEventListener('change', documentChangeHandler)
    }
  }, [mediaQuery])

  return isMatch
}
